angular.module('routes.login.LoginController', [
  'stack'
])

/**
 * The LoginController manages view logic rendered to the
 * login.html template for the /login login.
 *
 * @class LoginController
 * @constructor
 * @module routes.login.LoginController
 */
.controller('LoginController', [
  '$scope',
  '$state',
  '$window',
  'UsersService',
  'LoginService',
  function ($scope, $state, $window, UsersService, LoginService) {
    'use strict';

    $scope.user = null;
    $scope.submitting = false;

    $scope.error = {
      show: false,
      error: '',
      status: 0,
      message: ''
    };

    $scope.passwordValidation = {
      lower: null,
      upper: null,
      number: null,
      special: null,
      length: null,
      match: true,
      emailid: null,
      valid: false
    };


    $scope.submit = function (form) {
      /* console.log('TODO: submit login via SSL/TLS protected API');
      console.log('POST: ', { email:form.email.$modelValue, password:form.password.$modelValue });
      console.log('Assuming that works a user object will be returned.');
      console.log('For now I\'ll just grab one from the UsersService.');
      UsersService.setCurrent(UsersService.get(form.password.$modelValue, form.email.$modelValue));
      $scope.user = UsersService.getCurrent();
      console.log('UsersService.getCurrentt()', UsersService.getCurrent());
      console.log('Ther will also be a session token set on all API http requests');
      var token = uuid.v1();
      console.log('For now I\'ll just make one up.', token);
      console.log('Save user and token to localStorage for authoring');
      window.localStorage.newman = JSON
        .stringify({ user: UsersService.getCurrent().id, token: token });
      console.log('window.localStorage.newman', window.localStorage.newman);
      //console.log('Save user and token to sessionStorage for delivery');
      //window.sessionStorage.newman = JSON
      //  .stringify({ user: UsersService.getCurrent().id, token: token });
      //console.log('window.sessionStorage.newman', window.sessionStorage.newman);

      if (!$scope.user.content.changepw) {
        $state.go('routes.cases');
      }*/
      $scope.submitting = true;

      LoginService
        .login(form.email.$modelValue, form.password.$modelValue)
        .then(function (response) {
          $scope.submitting = false;
          LoginService.isAuthoring = true;
          LoginService.setToken(response.data.token);
          $window.localStorage.newman = JSON
            .stringify({
              user: response.data.userId,
              token: response.data.token,
              authoring: true
            });
          return LoginService.getUser(response.data.userId);
        })
        .then(function (userResponse) {
          $scope.submitting = false;
          $scope.user = userResponse;
          UsersService.setCurrent(userResponse);
          if (!$scope.user.content.changepw) {
            $state.go('routes.cases');
          }
          return;
        })
        .catch(function (err) {
          if (err.status === 401) {
            $scope.error = {
              show: true,
              error: err.data.error,
              status: err.status,
              message: err.statusText
            };
          }
          $scope.submitting = false;
          console.log(err);
        });
    };

    $scope.changePassword = function (form) {
      LoginService
        .changePassword(form.newpw.$modelValue, form.verifypw.$modelValue, $scope.user)
        .then(function (response) {
          console.log(response);
          $state.go('routes.cases');
          return;
        })
        .catch(function (response) {
          console.log(response);
        });
    };


    $scope.checkStrength = function (model) {
      var regexLower = new RegExp('^(?=.*[a-z])');
      var regexUpper = new RegExp('^(?=.*[A-Z])');
      var regexNumber = new RegExp('^(?=.*[0-9])');
      var regexSpecial = new RegExp('^(?=.*[-^!@#$%^&*-.])');
      var regexLength = new RegExp('^(?=.{8,})');

      if (model.newpw) {
        $scope.passwordValidation.lower = regexLower.test(model.newpw);
        $scope.passwordValidation.upper = regexUpper.test(model.newpw);
        $scope.passwordValidation.number = regexNumber.test(model.newpw);
        $scope.passwordValidation.special = regexSpecial.test(model.newpw);
        $scope.passwordValidation.length = regexLength.test(model.newpw);

        // FIXME can be combined into assignment statement
        if (model.newpw === model.verifypw) {
          $scope.passwordValidation.match = true;
        } else {
          $scope.passwordValidation.match = false;
        }

        // FIXME can be conbined into assignment statement
        if (model.newpw === $scope.user.content.email || model.newpw === $scope.user.id) {
          $scope.passwordValidation.emailid = true;
        } else {
          $scope.passwordValidation.emailid = false;
        }
      }

      // FIXME can be combined into assignment statement
      if (
        $scope.passwordValidation.lower
        && $scope.passwordValidation.upper
        && $scope.passwordValidation.number
        && $scope.passwordValidation.special
        && $scope.passwordValidation.length
        && $scope.passwordValidation.match
        && !$scope.passwordValidation.emailid
      ) {
        $scope.passwordValidation.valid = true;
      }
    };

    function clearUser() {
      LoginService.clearUser();
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      clearUser();
    }
    initialize();
  }
]);
